import { VolumeUnits } from '../graphql';
import { transformRecord } from '../lib/util';
import type { CubicMeters } from './cargoUnits';

type VolumeUnitItem = {
  short: string;
  name: string;
  value: string;
  constant: number;
};

export const CUBIC_METER_IN_CUBIC_FEET = 35.315;

const volumeUnitsRecord: Record<VolumeUnits, VolumeUnitItem> = {
  [VolumeUnits.M_3]: {
    short: 'm³',
    name: 'm³ : Cubic meters',
    value: 'M_3' as const,
    constant: 1,
  },
  [VolumeUnits.FT_3]: {
    short: 'ft³',
    name: 'ft³ : Cubic feet',
    value: 'FT_3' as const,
    constant: 0.0283168466,
  },
  [VolumeUnits.LCBM]: {
    short: 'lcbm',
    name: 'lcbm : Loose cubic meters',
    value: 'LOOSE_CBM' as const,
    constant: 1,
  },
  [VolumeUnits.SCBM_UB]: {
    short: 'scbm ub',
    name: 'scbm ub : Solid cubic meters under bark (scbm ub / m³fub / m³ub / m³sw )',
    value: 'SCBM_UB' as const,
    constant: 1,
  },
  [VolumeUnits.SCBM_OB]: {
    short: 'scbm ob',
    name: 'scbm ob : Solid cubic meters over bark',
    value: 'SCBM_OB' as const,
    constant: 1,
  },
  [VolumeUnits.M_3_TO]: {
    short: 'm³to',
    name: 'm³to : Top-end cylinder without bark',
    value: 'M_3_TO' as const,
    constant: 1,
  },
  [VolumeUnits.M_3_RW]: {
    short: 'm³rw',
    name: 'm³rw : Roundwood under bark',
    value: 'M_3_RW' as const,
    constant: 1,
  },
  [VolumeUnits.DT]: {
    short: 'DT',
    name: 'DT : Displacement Ton 35ft³',
    value: 'DT' as const,
    constant: 0.991089631,
  },
  [VolumeUnits.FT_US]: {
    short: 'FT US',
    name: 'FT / MTON : Freight / Measurement Ton USA 40ft³',
    value: 'FT_US' as const,
    constant: 1.13267386,
  },
  [VolumeUnits.FT_UK]: {
    short: 'FT UK',
    name: 'FT / MTON : Freight / Measurement Ton UK 42ft³',
    value: 'FT_UK' as const,
    constant: 1.18930756,
  },
  [VolumeUnits.GRT]: {
    short: 'GRT',
    name: 'GRT : Gross Register Ton 100ft³',
    value: 'GRT' as const,
    constant: 2.83168466,
  },
  [VolumeUnits.LITER]: {
    short: 'LITER',
    name: 'LITER : Liter',
    value: 'LITER' as const,
    constant: 0.001,
  },
  [VolumeUnits.TEU]: {
    short: 'TEU',
    name: 'TEU : Twenty-foot Equivalent Unit',
    value: 'TEU' as const,
    constant: NaN, // an inexact unit of cargo capacity, cannot convert to m³
  },
};

const volumeUnits = [...Object.values(volumeUnitsRecord)];

export default volumeUnits;

export const volumeUnitToConstant = transformRecord(
  volumeUnitsRecord,
  (item) => item.constant,
);

export function toM3(v: number, unit: VolumeUnits): CubicMeters {
  return (v * volumeUnitsRecord[unit].constant) as CubicMeters;
}
